function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M288 144v16h112v272H112V160h112v-16H96v304h320V144z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M193.1 118.1l-11.6-11.6L256 32l74.5 74.5-11.6 11.6-54.7-54.7v243h-16.4v-243z"
});

const SvgIosShareOutline = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512 512",
  ref: svgRef
}, props), _ref, _ref2);

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIosShareOutline, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ios-share-outline.4c3bea96.svg";
export { ForwardRef as ReactComponent };